<template>
  <div
    class="grid content-center items-center justify-center justify-items-center h-[50vh] text-center"
    role="status">
    <Spinner size="lg" />
    <span class="sr-only">Signing you out</span>
  </div>
</template>

<script>
import { signOut } from '@/utilities/SignOut';
import Spinner from '@/components/v2/Spinner.vue';

export default {
  name: 'Logout',
  components: { Spinner },
  async created() {
    await signOut();
  },
};
</script>
